<div class="main-content">
    <div class="main-heading">
        <span translate>ASSIGN_MANUALS</span>
    </div>
    <div class="card">
        <div class="card-body">
            <div class="mbtm-30">
                <div class="form-group" *ngIf="userRole!=2">
                    <label class="kuba-choice-label"><p-radioButton class="radio-marg"
                      (onClick)="onRadioTypeChange('Portal')" name="Portal" value="Portal" [(ngModel)]="selectedType"></p-radioButton><span>{{'PORTAL'|translate}}</span></label>
                    <label class="kuba-choice-label"><p-radioButton class="radio-marg"
                      (onClick)="onRadioTypeChange('Business')" name="Business" value="Business"
                      [(ngModel)]="selectedType"></p-radioButton><span>{{'BUSINESS'|translate}}</span></label>
                </div>
                <div class="input-btn-group">
                    <p-select [options]="typeList" [(ngModel)]="levelKey"
                      (onChange)="onChangeType($event,optionName)" id="typeList" [filter]="true"
                      [style]="{'width':'100%'}"></p-select>
                </div>
            </div>
            <div *ngIf="levelKey!=null" class="mbtm-30">
                <div class="page-title" translate>{{selectedType}} {{'MANUALS' |translate }}</div>
                <div class="table-view">
                    <assign-manual-list [CommonManuals]="assignManuals" [isAllCommonManual]="isAllCommonManual"
                      (onAssignManualEdit)="onBusinessOrPortalManualsEdit($event)" [ActiveList]="activeList"
                      [isBindCommonManual]="setbooleanFalse" [manualVersions]="manualVersionDropDown"
                      [userList]="userList" (onDeleteAssignedManual)="onDeleteAssignedManual($event)">
                    </assign-manual-list>
                </div>
            </div>
            <div>
                <span class="page-title" translate>COMMON_MANUAL</span>
                <assign-manual-list [CommonManuals]="CommonManuals" [roleId]="roleId"
                  [isAllCommonManual]="isAllCommonManual" [isBindCommonManual]="setbooleanTrue"
                  [isAssigning]="isAssigning"
                  (onAssignManualEdit)="onSelectedCommonManuals($event)"
                  (onPortalCommonManualEdit)="onPortalCommonManualsEdit($event)"
                  [manualVersions]="manualVersionDropDown">
                </assign-manual-list>
            </div>
        </div>
    </div>
</div>
<p-confirmDialog header="{{'CONFIRMATION'|translate}}" icon="pi pi-question-circle" width="425"
  acceptLabel="{{'SWITCH_YES'|translate}}" rejectLabel="{{'SWITCH_NO'|translate}}"></p-confirmDialog>